<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :multiple="multiple"
            :outlined="outlined"
            :hideDetails="hideDetails"
            :dense="dense"
            :class="classe"
            :classe="classe"
            :disabled="disabled"
            @change="$emit('change', $event)"
            @input="$emit('input', $event)"
        />
        
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectOfferItemDay',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        multiple: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: [Boolean,String],
            default: false
        },
        classe: {

        },
        disabled: {
            type: Boolean,
            default: false
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        bigOccupationAreaId(val){
            this.getItems();
        }
    },
    methods: {
        ...mapActions('grid', ['ActionIndexOfferItemDays']),        
        
        async getItems() {

            this.loading = true;
            this.items = [];

            var payload =  {
                find_columns: {
                    active: 1,
                },
                column_order: 'id',
            }

            await this.ActionIndexOfferItemDays(payload)
                    .then((res) => {
                        
                        this.items = res.data;
                        
                        this.selected = this.model;

                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>